export const TeamsThemes = {
    contrast: "contrast",
    dark: "dark",
    default: "default"
};